import { render, staticRenderFns } from "./StudentClassroom.vue?vue&type=template&id=4dff3a19&"
import script from "./StudentClassroom.vue?vue&type=script&lang=js&"
export * from "./StudentClassroom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports